import type { ReactNode } from 'react';

import './Tag.css';

type TagTone = 'neutral' | 'blue' | 'amber' | 'ink' | 'solid';

interface TagProps {
  children: ReactNode;
  /** Encodes evidence strength, never status. */
  tone?: TagTone;
  /** Uppercase sans instead of mono, for word labels rather than identifiers. */
  sans?: boolean;
  className?: string;
  /** The one-line definition an evidence badge carries, shown on hover. */
  title?: string;
}

export default function Tag({
  children,
  tone = 'neutral',
  sans = false,
  className,
  title,
}: TagProps) {
  const classes = [
    'tag',
    tone === 'neutral' ? null : `tag--${tone}`,
    sans ? 'tag--sans' : null,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <span className={classes} title={title}>
      {children}
    </span>
  );
}
